// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"0e52857a","142":"30ee9a78","190":"50a9f8ef","246":"e60d0321","303":"d6ad4e41","691":"0eb1e446","891":"5f98fdcc","964":"3c39352a"}[chunkId] + ".chunk.js";
};